import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'online-app-additional-resources',
  templateUrl: './additional-resources.component.html',
  styleUrls: ['./additional-resources.component.scss']
})
export class AdditionalResourcesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/additional-resources/additional-resources.component.ts